(function () {
  'use strict';

  // Load this file globally from theme.liquid, not from cart-addons.liquid.
  // This keeps delegated handlers alive when Shopify replaces cart drawer HTML.

  if (window.__milgenxCartAddonsBound) return;
  window.__milgenxCartAddonsBound = true;

  const CARD = '.cart-upsell-flat-card[lb-product-handle]';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parsePlanPrices(value) {
    try { return JSON.parse(value || '{}'); }
    catch (error) {
      console.error('[Cart Addons] Invalid selling plan prices:', error);
      return {};
    }
  }

  function readVariant(card) {
    const select = card.querySelector('.cart-variant-picker');

    if (select) {
      const option = select.options[select.selectedIndex];
      if (!option) return null;

      return {
        id: Number(option.value),
        price: Number(option.dataset.price),
        compare: Number(option.dataset.compare || 0),
        image: option.dataset.image,
        available: option.dataset.available === 'true',
        planIds: (option.dataset.planIds || '').split(',').filter(Boolean),
        planPrices: parsePlanPrices(option.dataset.planPrices)
      };
    }

    return {
      id: Number(card.dataset.defaultVariant),
      price: Number(card.dataset.defaultPrice),
      compare: Number(card.dataset.defaultCompare || 0),
      image: card.dataset.defaultImage,
      available: card.dataset.defaultAvailable === 'true',
      planIds: (card.dataset.defaultPlanIds || '').split(',').filter(Boolean),
      planPrices: parsePlanPrices(card.dataset.defaultPlanPrices)
    };
  }

  function updateCard(card) {
    const variant = readVariant(card);
    if (!variant) return;

    const button = card.querySelector('[data-add-upsell]');
    const image = card.querySelector('.cart-card-img');
    const subscription = card.querySelector('.cart-subscription-picker');
    const price = card.querySelector('.cart-price-sale-price');

    if (image && variant.image) image.src = variant.image;

    if (subscription) {
      Array.from(subscription.options).forEach(option => {
        option.disabled = option.value !== 'default' &&
          !variant.planIds.includes(String(option.value));
      });
      if (subscription.selectedOptions[0] && subscription.selectedOptions[0].disabled) {
        subscription.value = 'default';
      }
    }

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add' : 'Sold Out';
    }

    if (price) {
      const planId = subscription ? subscription.value : 'default';
      const selectedPrice = planId !== 'default' && variant.planPrices[planId] !== undefined
        ? Number(variant.planPrices[planId])
        : variant.price;

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        price.textContent = window.Shopify.formatMoney(
          selectedPrice,
          window.Shopify.money_format || '$'
        );
      }
    }
  }

  async function removeProductsAlreadyInCart() {
    try {
      const response = await fetch(ROOT + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;

      const cart = await response.json();
      const productIds = new Set(cart.items.map(item => String(item.product_id)));

      document.querySelectorAll(CARD).forEach(card => {
        const productId = String(card.dataset.productId || card.getAttribute('lb-product-id'));
        if (productIds.has(productId)) card.remove();
      });
    } catch (error) {
      console.warn('[Cart Addons] Could not check cart:', error);
    }
  }

  async function addProduct(button) {
    const card = button.closest(CARD);
    if (!card) throw new Error('Could not find the add-on product card.');

    const variant = readVariant(card);
    if (!variant || !variant.id || !variant.available) {
      throw new Error('This product option is unavailable.');
    }

    const subscription = card.querySelector('.cart-subscription-picker');
    const planId = subscription ? subscription.value : 'default';

    if (planId !== 'default' && !variant.planIds.includes(String(planId))) {
      throw new Error('This subscription is not available for the selected variant.');
    }

    const item = { id: variant.id, quantity: 1 };
    if (planId !== 'default') item.selling_plan = Number(planId);

    const response = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [item],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.description || result.message || 'Shopify could not add this product.');
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
      drawer.renderContents(result);
    } else {
      // Fallback: keep the product added and refresh the cart page/drawer state.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }

    card.remove();
    await removeProductsAlreadyInCart();
    return result;
  }

  async function handleAdd(button) {
    if (button.disabled || button.dataset.loading === 'true') return;

    const originalText = button.textContent.trim() || 'Add';
    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'Adding...';
    button.setAttribute('aria-busy', 'true');

    try {
      await addProduct(button);
    } catch (error) {
      console.error('[Cart Addons] Add failed:', error);
      button.disabled = false;
      button.textContent = originalText;
      alert(error.message || 'Unable to add this product. Please try again.');
    } finally {
      button.dataset.loading = 'false';
      button.removeAttribute('aria-busy');
    }
  }

  // Capture delegated events from cart drawer markup, including markup inserted later.
  function findAddButton(event) {
    const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
    return target && target.closest('[data-add-upsell]');
  }

  // Pointer events cover iOS Safari taps; click remains as a fallback.
  document.addEventListener('pointerup', function (event) {
    if (event.pointerType === 'mouse') return;
    const button = findAddButton(event);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    handleAdd(button);
  }, true);

  document.addEventListener('click', function (event) {
    const button = findAddButton(event);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    handleAdd(button);
  }, true);

  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const card = target.closest(CARD);
    if (!card) return;
    if (target.matches('.cart-variant-picker, .cart-subscription-picker')) {
      updateCard(card);
    }
  }, true);

  function initialize(root) {
    const scope = root || document;
    if (scope.matches && scope.matches(CARD)) updateCard(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(CARD).forEach(updateCard);
  }

  function start() {
    initialize(document);
    removeProductsAlreadyInCart();

    if ('MutationObserver' in window && document.body) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) initialize(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();